const featureOrderApi = ({ ordersMonitor }) => ({
    orders: {
        checkOrders: ordersMonitor.checkOrders,
    },
});
const ordersApiDefinition = {
    id: 'ordersApi',
    type: 'api',
    factory: featureOrderApi,
    dependencies: ['ordersMonitor'],
};
export default ordersApiDefinition;
